import React from 'react';

interface CheckboxInputProps {
    label: string;
    name: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
    label,
    name,
    checked,
    onChange,
    required = false
}) => {
    return (
        <div className="checkbox-option">
            <input
                type="checkbox"
                id={name}
                name={name}
                checked={checked}
                onChange={onChange}
            />
            <label htmlFor={name} className={required ? 'required-field' : ''}>{label}</label>
        </div>
    );
};

export default CheckboxInput;